import { ThreeDS } from "../api/Client";
export class SwapayThreeDsAuthorizationError extends Error {
    constructor(message) {
        super();
        this.message = message;
    }
}
export function useThreeDsAuthorization() {
    const handler = async (authorizationUrl, cacheKey) => {
        const authorizationWindow = window.open(authorizationUrl, '_blank', 'width=480,height=640,popup');
        if (!authorizationWindow) {
            throw new SwapayThreeDsAuthorizationError('ポップアップを開けませんでした。ポップアップの許可をしてください。');
        }
        // 状態を見て閉じる
        await new Promise((resolve, reject) => {
            const intervalRef = setInterval(async () => {
                const { data } = await ThreeDS.getStatus(cacheKey);
                if (data.status === 'END') {
                    clearInterval(intervalRef);
                    authorizationWindow.close();
                    setTimeout(() => {
                        data.errorMessages.length === 0 ? resolve() : reject(new SwapayThreeDsAuthorizationError(data.errorMessages[0]));
                    }, 1000);
                }
            }, 1000);
        });
    };
    return handler;
}
